<template>
  <div class="rent-lessee-dialog">
      <custom-dialog
      :title="model.title" :visible="visible" v-on="$listeners"
      width="80%"
    >
      <div class="dialog-body">
        <div class="title"><div class="tag centerY"></div><span>{{ $t('crm_lessee_equipment_dialog.zu_lin_fang_xin_xi') }}</span></div>
        <el-row style="margin-bottom: 12px;">
          <el-col :span="8" >
            {{ $t('crm_lessee_equipment_dialog.zlfmc') }}：{{info.partnerName}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.zu_lin_fang_dian_hua') }}：{{info.mobilePhone}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.zlfyx') }}：{{info.email}}
          </el-col>
        </el-row>
        <el-row  style="margin-bottom: 12px;">
          <el-col :span="8" >
            {{ $t('crm_lessee_equipment_dialog.gong_si_gui_mo') }}：{{getDicValue('crm_partner_scale', info.partnerScaleName)}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.ying_ye_zhi_zhao') }}：{{info.businessLicense}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.zu_lin_fang_di_zhi') }}：{{info.address}}
          </el-col>
        </el-row>
        <el-row  style="margin-bottom: 12px;">
          <el-col :span="8" >
            {{ $t('crm_lessee_equipment_dialog.fa_ren_xing_ming') }}：{{info.legalPerson}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.frsfz') }}：{{info.legalPersonIdentity}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.zlfwz') }}：{{info.website}}
          </el-col>
        </el-row>
        <el-row  style="margin-bottom: 12px;">
          <el-col :span="8" >
            {{ $t('crm_lessee_equipment_dialog.zhu_ce_zi_jin') }}：{{info.currencyUnit}}{{info.registeredCapital}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.chuang_jian_gong_si') }}：{{info.company}}
          </el-col>
          <el-col :span="8">
            {{ $t('crm_lessee_equipment_dialog.chuang_jian_ren') }}：{{info.creator}}
          </el-col>
        </el-row>
        <div class="table-box">
          <el-row :gutter="50">
            <el-col :span="12">
              <!-- <div class="title"><div class="tag centerY"></div><span>{{ $t('p_groupRelation_wglsb') }}</span></div> -->
              <div class="search-hd">
                <el-form :inline="true" @submit.native.prevent>
                  <div class="title" style="float: left">
                    <div class="tag centerY"></div>
                    <span>{{ $t('crm_lessee_equipment_dialog.wglsb') }}</span>
                  </div>
                  <!-- 搜索项 -->
                  <el-form-item style="float: right; margin-right: 0">
                    <el-input :placeholder="$t('crm_lessee_equipment_dialog.ji_shen_hao')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 180px">
                      <template slot="append">
                        <div @click="onPageChange({ page: 1 })">
                          <i class="icon icon-search"></i>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item style="float: right">
                    <el-input :placeholder="$t('crm_lessee_equipment_dialog.xiang_mu_ming_cheng')" v-model="formSearch.locationName" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 180px">
                      <template slot="append">
                        <div @click="onPageChange({ page: 1 })">
                          <i class="icon icon-search"></i>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
              <el-table
               ref="tb1"
                :data="rentLsseeList"
                :size="allTableSize"
                @selection-change="selectionChange($event, 'selectLessee')"
                @sort-change="sortChange">
                <el-table-column type="selection" width="44" fixed="left"></el-table-column>
                <el-table-column
                  prop="bodyNum"
                  :label="$t('crm_lessee_equipment_dialog.ji_shen_hao')">
                </el-table-column>
                <el-table-column
                  prop="productCode"
                  :label="$t('crm_lessee_equipment_dialog.xing_hao')">
                </el-table-column>
                <el-table-column
                  prop="locationName"
                  :label="$t('crm_lessee_equipment_dialog.xiang_mu_ming_cheng')">
                </el-table-column>
              </el-table>
              <div class="table-page">
                <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="title"><div class="tag centerY"></div><span>{{ $t('crm_lessee_equipment_dialog.yi_xuan_ze_she_bei') }}</span></div>
              <el-table
               ref="tb1"
                :data="rentLsseeRight"
               :size="allTableSize"
                @sort-change="sortChange">
                <el-table-column type="selection" width="44" fixed="left"></el-table-column>
                <el-table-column
                  prop="bodyNum"
                  :label="$t('crm_lessee_equipment_dialog.ji_shen_hao')">
                </el-table-column>
                <el-table-column
                  prop="productCode"
                  :label="$t('crm_lessee_equipment_dialog.xing_hao')">
                </el-table-column>
                <el-table-column
                  prop="locationName"
                  :label="$t('crm_lessee_equipment_dialog.xiang_mu_ming_cheng')">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>


      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveLessee">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          title: ''
        };
      }
    }
  },
  data() {
    return {
      visible: false,
      // tableCode: 'related_lessee',
      selectLessee: [],
      rentLsseeList: [],
      // 右边表格
      rentLsseeRight: [],
      formSearch: {
        roleId: '',
        search: '',
        locationName: '',
        pageSize: 20,
        pageNum: 1,
        isAssociated: 0,
        bizId: ''
      },
      totalRows: 0,
      info: {}
    };
  },

  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.formSearch = JSON.parse(this.resetFormSearch);
      // this.dialogData.partnerId = this.partnerId;
      // console.log(this.data.partnerId);
      this.formSearch.partnerId = this.data.partnerId;

      // 租赁方id
      this.formSearch.partnerOrgId = this.data.partnerOrgId;
      this.formSearch.bizId = this.data.largeCustomerId;
      this.getLesseePage();
      // this.getTableColumn();
      this.getInfo();
    },
    // 选中
    selectionChange: function (selection, name) {
      this[name] = selection;
      this.rentLsseeRight = selection;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取详情
    getInfo: function () {
      this.$getJSON(apis.partnerInfo, { partnerId: this.formSearch.partnerId, creatorInfo: true }).then((res) => {

        this.info = { ...res.data, ...this.data };
        // console.log(this.data);

      });
    },
    // 获取关联列表
    getLesseePage: function () {
      const from = {
        ...this.formSearch,
        bizId: this.data.largeCustomerId,
        customerId: this.data.customerId,
        bizType: 1,

      };
      this.$getJSON(apis.BizDevicePage, from).then((res) => {

        this.rentLsseeList = res.data.list || [];
        this.totalRows = res.data.total;

      });
    },

    // 保存关联
    saveLessee: function () {
      if (this.selectLessee.length < 1) {
        this.$message.error(this.$t('crm_lessee_equipment_dialog.qxzgldsb'));
      } else {
        const ids = this.selectLessee.map(t => t.deviceId);
        const parms = {
          bizId: this.formSearch.bizId,
          bizType: 1,
          deviceIds: ids,
          parentOrgId: 0,
          bizOrgId: this.info.partnerOrgId
        };
        this.$postJSON(apis.DeviceBind, parms).then(() => {

          this.$emit('success');
          this.closeDialog();

        });
      }
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLesseePage();
    },

  }
};
</script>

<style lang="scss">
.rent-lessee-dialog{
  .dialog-body{
    .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom:10px;
      .tag {
        width: 4px;
        height: 15px;
        background-color: #00afff;
        left: 0;
      }
    }
  }
  .table-box{
    margin-top: 20px;
  }
}
</style>
